import { lazy } from 'react'

export const SleepingTimeFeedback = lazy(() => import('./SleepingTimeFeedback'))
